import { render, staticRenderFns } from "./AssessmentSummary.vue?vue&type=template&id=53e1c9d8&"
import script from "./AssessmentSummary.vue?vue&type=script&lang=js&"
export * from "./AssessmentSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports